<template>
  <svg class="three-arrows-comp" width="100%" height="100%" viewBox="0 0 24 15">
    <g >
        <path
          ref="arrow0"
          class="arrow"
          d="M1.804,12l2.267,-4.5l-0.767,-1.6l-1.467,-2.9l-1.5,-3l3.717,0l3.75,7.5l-3.75,7.5l-3.75,0"
          style="opacity: 0; transform: scale(0.85) translateX(-8px);"
          :style="{ fill: arrowColor}"
        />
        <path
          ref="arrow1"
          class="arrow"
          d="M1.804,12l2.267,-4.5l-0.767,-1.6l-1.467,-2.9l-1.5,-3l3.717,0l3.75,7.5l-3.75,7.5l-3.75,0"
          :style="{ fill: arrowColor}"
        />
        <path
          ref="arrow2"
          class="arrow"
          d="M9.804,12l2.267,-4.5l-0.767,-1.6l-1.467,-2.9l-1.5,-3l3.717,0l3.75,7.5l-3.75,7.5l-3.75,0"
          :style="{ fill: arrowColor}"
        />
        <path
          ref="arrow3"
          class="arrow"
          d="M17.804,12l2.267,-4.5l-0.767,-1.6l-1.467,-2.9l-1.5,-3l3.717,0l3.75,7.5l-3.75,7.5l-3.75,0"
          :style="{ fill: arrowColor}"
        />
    </g>
</svg>
</template>

<script>
    //import comp from '@/path/to/comp.vue';    //от папки src указанной в webpack
    import anime from 'animejs'
    import {Subject} from "rxjs/Subject";
    export default {
      name: 'three-arrows-comp',
      props: {
          color: {
            type: String,
            default: 'white', //orange , white
          },
          isInfinityAnimated: {
            type: Boolean,
            default:false,
          },
          animatePerInterval: {
            type: Boolean,
            default: false,
          },
          onlyOddInterval:{
            type: Boolean,
            default: false
          }
        },
      data(){
        return {
          timeline: null, //делается в mounted,
          rxAnimationFinishedSubject: new Subject()
        }
      },
      computed:{
        arrowColor(){
            switch(this.color) {
              case 'orange':
                return '#D9480F'
                break
              case 'white':
                return '#ffffff'
                break
              default:
                return 'white'
            }
          }
      },
      watch: {
        isInfinityAnimated(newVal){
          if (newVal){
            this.timelinePlay();
          } else {
            this.timelinePause()
          }
        }
      },
      methods: {
        //public
        createTimeline(){
          let duration = 365;
          let easing = 'linear';

          let timeline = anime.timeline({
            duration,
            easing,
            loop:true,
            autoplay: false,
            update: (anim) => {
              if (anim.progress ==  100
                && !this.isInfinityAnimated
              ) {
                this.rxAnimationFinishedSubject.next('44');
              }
            }

          });


          timeline
            .add({
              targets: this.$refs.arrow3,
              translateX: '8',
              scale: 0.85,
              opacity: 0.0,

              offset: 0,

            })
            .add({
              targets: this.$refs.arrow2,
              translateX: '8',
              offset: 0,
            })
            .add({
              targets: this.$refs.arrow1,
              translateX: '8',
              offset: 0,
            })
            .add({
              targets: this.$refs.arrow0,
              opacity: 1,
              translateX: '0',
              scale: 1,
              offset:0
            })
          this.timeline = timeline;
        },
        timelinePlay(){
          if (!(window.navigator.userAgent.indexOf("Edge") > -1)) {
            this.timeline.play();
          }
        },
        timelinePause(){
          let mySubscription = this.rxAnimationFinishedSubject.subscribe((val)=>{
            this.timeline.restart()
            this.timeline.pause();
            mySubscription.unsubscribe()  // once-костыль
          })
        }
      },
      mounted(){
        this.createTimeline()

        let intervalCounter = 0;
        setInterval(()=>{
          intervalCounter++;
          if(this.animatePerInterval) {
            //Если нечетный
            if (!(Math.abs(intervalCounter % 2) == 0)) {
              this.timelinePlay();
              this.timelinePause();
            } else {
              // console.log('пропускаем анимацию')
            }
          } else {
            this.timelinePlay();
            this.timelinePause();
          }
        },3000)
      }

    }
</script>
<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
    .three-arrows-comp{
      overflow: visible;
      /*outline: 1px solid darkred;*/
      width: calc(var(--px) * 24);
      height:calc( 15 * var(--px));
      .arrow {
        transition: fill $timeShort;
        transform-origin: center center;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/three-arrows-comp.vue